'use client';

import React, { ReactNode } from 'react';
import { ThemeProvider } from './ThemeProvider';
import { FontSizeProvider } from './FontSizeProvider';
import { SidebarProvider } from './SidebarProvider';

interface UIProviderProps {
  children: ReactNode;
}

/**
 * UIProvider - UI preference providers
 * 
 * Combines UI-related providers:
 * - Theme management (light/dark/system)
 * - Font size preferences
 * - Sidebar state
 */
export function UIProvider({ children }: UIProviderProps) {
  return (
    <ThemeProvider>
      <FontSizeProvider>
        <SidebarProvider>
          {children}
        </SidebarProvider>
      </FontSizeProvider>
    </ThemeProvider>
  );
}